import $ from 'jquery';

$(function () {
  const scrollTopButton = $('.js-scrollTop');

  // $(window).on('scroll', function () {
  //   // スクロール量が100px以上になったときにトップボタンを表示
  //   if ($(this).scrollTop() > 200) {
  //     scrollTopButton.css('transform', 'translateY(0)');
  //   } else {
  //     scrollTopButton.css('transform', 'translateY(12rem)');
  //   }

  //   // フッターまでスクロールするとトップボタンをフッターの上に固定
  //   const footerOffset = $('.p-footer').offset().top;
  //   const scrollTop = $(window).scrollTop();
  //   const windowHeight = $(window).height();

  //   if (scrollTop + windowHeight > footerOffset + 82) {
  //     scrollTopButton.addClass('is-on-footer');
  //   } else {
  //     scrollTopButton.removeClass('is-on-footer');
  //   }
  // });

  // クリックでページトップにスクロール
  scrollTopButton.on('click', function () {
    $('html, body').animate({ scrollTop: 0 }, 500);
  });
});
